import _ from "lodash";
import { getCurrentWebsite } from "../../helpers/getCurrentWebsite";
import { getCurrentWebsitePage } from "../../helpers/getCurrentWebsitePage";
import { getCurrentWebsitePageUrl } from "../../helpers/getCurrentWebsitePageUrl";
import { WebsitesState } from "../websites/types";
import {
  addWebsitePageComponent,
  changePageDynamicData,
  changeWebsitePageComponentContent,
  changeWebsitePagesStateGlobalData,
  cloneWebsitePageWaitingForServer,
  deleteWebsitePageWaitingForServer,
  editApiSourceValidationData,
  incrementEditorKey,
  pasteCopiedWebsitePageComponent,
  removeSingleWebsitePageFromStore,
  saveWebsitesPagesInState,
  setPageLoadStatus,
  toggleNewWebsitePageEditionsDetected,
} from "./actions";
import { WebsitePagesState } from "./types";
import generateContentDataObject from "../../helpers/editor/generateContentDataObject";
import { createPageAsync } from "../../helpers/async/createPageAsync";
import { getActualComponentName } from "../../helpers/getActualComponentName";
import { api, apiUrlBase, sheetsApi } from "../../data/urls";
import axios from "axios";
import { openNotification } from "../../helpers/openNotification";
import {
  DEFAULT_ERROR_MESSAGE,
  DEFAULT_ERROR_TITLE,
  notificationDuration,
} from "../../data/constants";
import { checkIfGoogleSheetUrl } from "../../helpers/checkIfGoogleSheetUrl";
import { getCurrentStoreData } from "../websites/thunks";
import { validateGoogleSheetAsync } from "../../helpers/async/validateGoogleSheetAsync";
import { AuthState } from "../auth/types";
import { CmsType, LoadStatus } from "../../enums/enums";
import returnAuthHeaderForAJAX from "../../helpers/auth/returnAuthHeaderForAJAX";
import { removeFromClipboard } from "../user/actions";
import { formatGoogleSheetUrl } from "../../helpers/formatGoogleSheetUrl";
import { getUniqueKeys } from "../../helpers/getUniqueKeys";
import getUrlParameter from "../../helpers/getUrlParameter";
import { changeWebsitesStateGlobalData } from "../websites/actions";
import { getFullPageUrl } from "../../helpers/editor/getFullPageUrl";
import { checkIfPageIsDynamic } from "../../helpers/checkIfPageIsDynamic";
import addNoCacheParamToURL from "../../helpers/editor/addNoCacheParamToURL";
import { clonePageAsync } from "../../helpers/async/clonePageAsync";
import { deletePageAsync } from "../../helpers/async/deletePageAsync";

const generator = new generateContentDataObject();

export const addAndReturnWebsitePageComponent = (payload) => {
  return (dispatch, getState) => {
    dispatch(addWebsitePageComponent(payload));
    const { items } = getState().websitesPages;
    const { currentPageIndex, indexToPlace } = payload;
    const currentPage = items[currentPageIndex];
    const componentsArray = currentPage.page_components.data.schema;
    const newComponent = componentsArray[indexToPlace];
    return newComponent;
  };
};

export const clearWebsitePage = () => {
  return (dispatch, getState) => {
    const websites: WebsitesState = getState().websites;
    const websitesPages: WebsitePagesState = getState().websitesPages;

    const currentWebsite = getCurrentWebsite(websites.items);
    const currentPageUrl = getCurrentWebsitePageUrl(
      currentWebsite,
      websitesPages.items
    );
    const currentWebsitePage = getCurrentWebsitePage(
      currentPageUrl,
      websitesPages.items,
      currentWebsite
    );
    const currentPageIndex = websitesPages.items.indexOf(currentWebsitePage);
    const pageComponents = currentWebsitePage.page_components.data.schema;

    pageComponents.forEach((component, index) => {
      const componentName = getActualComponentName(component);
      const componentCopy = _.cloneDeep(component);
      let { componentData } = componentCopy;
      Object.keys(componentData).forEach((contentType) => {
        if (contentType === "title") {
          componentData.title.content.markup = "";
        }
        if (contentType === "subtitleText") {
          componentData.subtitleText.content.markup = "";
        }
        if (contentType === "cta") {
          componentData.cta.content.form.button.title = "";
          componentData.cta.content.form.fields.items = [];
          componentData.cta.content.buttons = [];
          componentData.cta.ctaBottomInfo.markup = "";
        }
        if (contentType === "features") {
          componentData.features.content.items = [];
        }
        if (contentType === "list") {
          componentData.list.content.items = [];
          componentData.list.content.groups = [];
        }
        if (contentType === "posts") {
          if (!componentName.startsWith("photos-01")) {
            componentData.posts.content.items = [];
          }
        }
        if (contentType === "gallery") {
          if (!componentName.startsWith("slider")) {
            componentData.gallery.content.items = [];
          }
        }
        if (contentType === "pricing") {
          if (componentName.startsWith("pricing-03")) {
            componentData.pricing.content.items[0].title = "";
            componentData.pricing.content.items[0].primaryInfo = "";
            componentData.pricing.content.items[0].monthlyPrice = "";
            componentData.pricing.content.items[0].yearlyPrice = "";
            componentData.pricing.content.items[0].monthlyPeriod = "";
            componentData.pricing.content.items[0].yearlyPeriod = "";
            componentData.pricing.content.items[0].currencySymbol = "";
            componentData.pricing.content.items[0].secondaryInfo = "";
            componentData.pricing.content.items[0].button.title = "";
            componentData.pricing.content.items[0].button.href = "";
            componentData.pricing.content.items[0].detailsSet = [];
            componentData = generator.addEmptyPricingDetailIfNeeded(
              componentData,
              0
            );
          } else {
            componentData.pricing.content.items = [];
          }
        }
        if (contentType === "steps") {
          componentData.steps.content.items = [];
        }
        if (contentType === "text") {
          componentData.text.content.items.forEach((item) => {
            item.markup = "";
          });
        }
        if (contentType === "team") {
          if (!componentName.startsWith("team-01")) {
            componentData.team.content.items = [];
          }
        }
        if (contentType === "faq") {
          componentData.faq.content.items = [];
          componentData = generator.addEmptyFaqIfNeeded(componentData);
        }
        if (contentType === "contacts") {
          componentData.contacts.content.items = [];
          componentData.contacts.content.map.mapTitle = "";
          componentData.contacts.content.map.url = "";
          componentData = generator.addEmptyContactIfNeeded(componentData);
        }
        if (contentType === "socialLinks") {
          componentData.socialLinks.content.items = [];
          componentData.socialLinks.content.title = "";
          componentData = generator.addEmptySocialLinkIfNeeded(componentData);
        }
        if (contentType === "code") {
          if (!componentName.startsWith("other-01")) {
            componentData.code.content.codeSnippet = "";
            componentData.code.content.gistUrl = "";
            componentData.code.content.subtitle = "";
            componentData.code.content.title = "";
          }
        }
      });
      dispatch(
        changeWebsitePageComponentContent({
          currentPageIndex,
          componentKey: index,
          componentData,
        })
      );
      dispatch(toggleNewWebsitePageEditionsDetected(true));
    });
  };
};

export const createAndSavePageAsync = (
  pageUrl: string,
  templateId?: number,
  defaultHtml?: string
) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const websites = getState().websites;
      const auth = getState().auth;
      const subdomain = getCurrentWebsite(websites.items).subdomain;
      createPageAsync({
        accessToken: auth.accessToken,
        subdomain,
        pageUrl,
        templateId,
        defaultHtml,
      })
        .then((response) => {
          dispatch(
            setPageLoadStatus({
              pageId: response.data.id,
              status: LoadStatus.LOADED,
            })
          );
          dispatch(saveWebsitesPagesInState([response.data]));
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
};

export const fetchAndSaveApiValidationData = (
  api_source_url: string,
  cancelTokenSourceRef,
  successMessage?: string
) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { currentWebsitePage } = dispatch(getCurrentStoreData());
      const auth: AuthState = getState().auth;

      if (!checkIfGoogleSheetUrl(api_source_url)) {
        if (
          typeof api_source_url === "string" &&
          api_source_url.startsWith("https://docs.google.com/spreadsheets")
        ) {
          dispatch(
            editApiSourceValidationData({
              pageId: currentWebsitePage.id,
              newData: {
                data: {
                  status: "error",
                  type: "front:generic_url",
                },
              },
            })
          );
        }
        return;
      }
      dispatch(
        editApiSourceValidationData({
          pageId: currentWebsitePage.id,
          newData: {
            isLoading: true,
          },
        })
      );

      if (!cancelTokenSourceRef.current) {
        cancelTokenSourceRef.current = axios.CancelToken.source();
      }
      const purgeCacheParameter = currentWebsitePage.api_cache_purge_parameter
        ? `&purge_cache=${currentWebsitePage.api_cache_purge_parameter}`
        : "";
      validateGoogleSheetAsync({
        accessToken: auth.accessToken,
        sheetUrl: api_source_url,
        cancelToken: cancelTokenSourceRef.current.token,
        purgeCacheParameter,
      })
        .then(({ data }) => {
          dispatch(
            editApiSourceValidationData({
              pageId: currentWebsitePage.id,
              newData: {
                data,
              },
            })
          );
          if (successMessage) {
            openNotification(
              "Success",
              successMessage,
              "OK",
              "success",
              notificationDuration.short
            );
          }
          resolve(data);
        })
        .catch((error) => {
          console.error(error);
          const responseData = _.get(error, "response.data");
          console.log("responseData: ", responseData);
          if (responseData) {
            dispatch(
              editApiSourceValidationData({
                pageId: currentWebsitePage.id,
                newData: {
                  data: responseData,
                },
              })
            );
          } else {
            dispatch(
              editApiSourceValidationData({
                pageId: currentWebsitePage.id,
                newData: {
                  data: {
                    status: "error",
                    type: "unknown_request_error",
                    details: error.message,
                  },
                },
              })
            );
          }
          reject(error);
        })
        .finally(() => {
          dispatch(
            editApiSourceValidationData({
              pageId: currentWebsitePage.id,
              newData: {
                isLoading: false,
              },
            })
          );
        });
    });
  };
};

export const fetchAndSavePageTemplatesAsync = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const cacheParam = getState().meta.cache;
      dispatch(
        changeWebsitePagesStateGlobalData({
          data: {
            pageTemplatesLoadedStatus: "loading",
          },
        })
      );
      const url = `${api.websitePages.fetchPageTemplates}?v=${cacheParam}`;
      axios
        .get(url)
        .then((response) => {
          dispatch(
            changeWebsitePagesStateGlobalData({
              data: {
                pageTemplatesLoadedStatus: "loaded",
                pageTemplatesArray: response.data,
              },
            })
          );
          resolve(response);
        })
        .catch((error) => {
          dispatch(
            changeWebsitePagesStateGlobalData({
              data: {
                pageTemplatesLoadedStatus: "error",
              },
            })
          );
          console.error(error.response);
          openNotification(
            DEFAULT_ERROR_TITLE,
            "Couldn't load page templates. Please reload the page. If it didn't help, contact us.",
            "OK",
            "error",
            notificationDuration.medium
          );
          reject(error);
        });
    });
  };
};

export const getPageLoadStatus = (pageId) => {
  return (dispatch, getState) => {
    if (!pageId) {
      return LoadStatus.NO_DATA;
    }
    const websitesPages = getState().websitesPages;
    const currentStatus = websitesPages.pageLoadStatusArray.find((item) => {
      return item.pageId === pageId;
    });
    return _.get(currentStatus, "status", LoadStatus.NOT_LOADED);
  };
};

export const getWebsiteInitialPagesLoadStatus = (website) => {
  return (dispatch, getState) => {
    if (!website) {
      return LoadStatus.NO_DATA;
    }
    const websitesPages = getState().websitesPages;
    const currentStatus = websitesPages.initialPagesLoadStatusArray.find(
      (item) => {
        return item.websiteId === website.id;
      }
    );
    return _.get(currentStatus, "status", LoadStatus.NOT_LOADED);
  };
};

export const fetchAndSaveCollectionKeys = (collectionId: string) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const auth: AuthState = getState().auth;
      const { currentWebsitePage } = dispatch(getCurrentStoreData());
      dispatch(
        editApiSourceValidationData({
          pageId: currentWebsitePage.id,
          newData: {
            isLoading: true,
          },
        })
      );
      axios
        .get(
          `${apiUrlBase}/api/v1/websites/get_collection_keys?collection_id=${collectionId}`,
          { ...returnAuthHeaderForAJAX(auth.accessToken) }
        )
        .then((response) => {
          dispatch(
            editApiSourceValidationData({
              pageId: currentWebsitePage.id,
              newData: {
                data: {
                  keys: response.data,
                  type: "hide_validation",
                },
              },
            })
          );
          resolve(response);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        })
        .finally(() => {
          dispatch(
            editApiSourceValidationData({
              pageId: currentWebsitePage.id,
              newData: {
                isLoading: false,
              },
            })
          );
        });
    });
  };
};

export const pasteCopiedComponent = ({
  copiedComponentJSON,
  indexToPlace,
  currentPageIndex,
}) => {
  return (dispatch, getState) => {
    if (!copiedComponentJSON) return;
    dispatch(
      pasteCopiedWebsitePageComponent({
        pastedComponentData: copiedComponentJSON,
        indexToPlace,
        currentPageIndex,
      })
    );
    dispatch(
      removeFromClipboard({
        key: "component",
      })
    );
    dispatch(toggleNewWebsitePageEditionsDetected(true));
  };
};

export const getPageDynamicData = ({ page }) => {
  return (dispatch, getState) => {
    const result = {
      isLoading: false,
      slugs: [],
      items: [],
      slugField: "",
      columns: [],
      allSlugs: [],
    };
    if (!page) return result;
    const websitesPages = getState().websitesPages;
    const pageDynamicData =
      _.get(websitesPages, ["pageDynamicData", page.id]) || {};
    result.slugs = pageDynamicData.slugs || result.slugs;
    result.items = pageDynamicData.items || result.items;
    result.slugField = pageDynamicData.slugField || result.slugField;
    result.isLoading = pageDynamicData.isLoading || result.isLoading;
    result.columns = pageDynamicData.columns || result.columns;
    result.allSlugs = pageDynamicData.allSlugs || result.allSlugs;
    return result;
  };
};

export const callPageSource = ({
  page,
  isFull,
}: {
  page: any;
  isFull?: boolean;
}) => {
  return (dispatch, getState) => {
    const pageDynamicData = dispatch(
      getPageDynamicData({
        page,
      })
    );
    if (!isFull && pageDynamicData.slugs.length > 0) return;
    if (isFull && pageDynamicData.allSlugs.length > 0) return;

    let formattedCmsUrl = "";
    const headers = {};
    const cmsType = _.get(page, "cms.cmsType", "googleSheets");
    if (cmsType === CmsType.CUSTOM) {
      dispatch(
        changePageDynamicData({
          pageId: page.id,
          data: {},
        })
      );
      return;
    }
    if (cmsType === CmsType.UNICORN) {
      const unicornCollectionId = _.get(page, "cms.unicorn.collectionId");
      if (!unicornCollectionId) {
        return;
      }
      formattedCmsUrl = `${sheetsApi}/cms/items?collection_id=${unicornCollectionId}&limit=${
        isFull ? 3500 : 4
      }&no_cache=true`;
      headers["Cache-Control"] = "no-cache";
    }
    if (cmsType === CmsType.GOOGLE_SHEETS) {
      const cmsUrl = _.get(
        page,
        "cms.googleSheets.url",
        _.get(page, "api_source_url")
      );
      if (!cmsUrl) {
        return;
      }
      formattedCmsUrl = `${formatGoogleSheetUrl(cmsUrl)}&limit=${
        isFull ? 3500 : 4
      }`;
    }
    if (!formattedCmsUrl) {
      return;
    }
    dispatch(
      changePageDynamicData({
        pageId: page.id,
        data: {
          isLoading: true,
        },
      })
    );
    const slugsKey = isFull ? "allSlugs" : "slugs";
    axios
      .get(formattedCmsUrl, { headers })
      .then((response) => {
        if (cmsType === CmsType.UNICORN) {
          const slugs = response.data.map((item) => item.slug);
          dispatch(
            changePageDynamicData({
              pageId: page.id,
              data: {
                [slugsKey]: [...new Set(slugs)],
                items: response.data,
                slugField: "slug",
                columns: getUniqueKeys(response.data),
                isLoading: false,
              },
            })
          );
        }
        if (cmsType === CmsType.GOOGLE_SHEETS) {
          const slugs = response.data.pages;
          const { keys } = response.data;
          dispatch(
            changePageDynamicData({
              pageId: page.id,
              data: {
                [slugsKey]: [...new Set(slugs)],
                items: response.data.items,
                slugField: keys.includes("pageurl")
                  ? "pageurl"
                  : keys.includes("page")
                  ? "page"
                  : "slugified_title",
                columns: getUniqueKeys(response.data.items),
                isLoading: false,
              },
            })
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

export const handleOnClickPage = ({
  pageId,
  slug,
  history,
}: {
  pageId: number;
  history: any;
  slug?: string;
}) => {
  return (dispatch, getState) => {
    const prevSlug = getUrlParameter("slug");
    const { currentWebsitePage, currentWebsite } = dispatch(
      getCurrentStoreData()
    );
    if (
      (prevSlug || "") === (slug || "") &&
      pageId === _.get(currentWebsitePage, "id")
    ) {
      window.scrollTo(0, 0);
      dispatch(incrementEditorKey());
      return;
    }
    if (pageId !== _.get(currentWebsitePage, "id")) {
      window.scrollTo(0, 0);
    }
    let url = `/${_.get(currentWebsite, "subdomain")}/pages/${pageId}`;
    if (slug) {
      url += `?slug=${slug}`;
    }
    history.push(url);
    if (
      pageId !== _.get(currentWebsitePage, "id") ||
      (slug || "") !== (prevSlug || "")
    ) {
      const websites = getState().websites;
      dispatch(
        changeWebsitesStateGlobalData({
          cmsRerenderKey: websites.cmsRerenderKey + 1,
        })
      );
    }
  };
};

export const previewPage = (pageId: number) => {
  return (dispatch, getState) => {
    const websitesPages = getState().websitesPages;
    const page = websitesPages.items.find((item) => item.id === pageId);
    if (!page) return;
    const websites = getState().websites;
    const website = websites.items.find((item) => item.id === page.website);
    if (!website) return;
    let fullPageUrl = getFullPageUrl(website, page.url);
    const slugParam = getUrlParameter("slug");
    if (slugParam) {
      fullPageUrl += slugParam;
    } else {
      if (checkIfPageIsDynamic(page)) {
        const { slugs } = dispatch(
          getPageDynamicData({
            page,
          })
        );
        if (slugs.length > 0) {
          fullPageUrl += slugs[0];
        }
      }
    }
    window.open(addNoCacheParamToURL(fullPageUrl), `pagePreview-${pageId}`);
  };
};

export const duplicatePage = (page) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!page) return;
      const { auth } = getState();
      const { currentWebsite } = dispatch(getCurrentStoreData());
      dispatch(cloneWebsitePageWaitingForServer(true));
      clonePageAsync({
        accessToken: auth.accessToken,
        subdomain: _.get(currentWebsite, "subdomain"),
        pageUrl: page.url || "home",
      })
        .then((response) => {
          dispatch(
            setPageLoadStatus({
              pageId: response.data.id,
              status: LoadStatus.LOADED,
            })
          );
          dispatch(saveWebsitesPagesInState([response.data]));
          resolve(response);
        })
        .catch((error) => {
          console.error(error.response);
          const warningMessage = _.get(error, "response.data.limit");
          if (warningMessage) {
            openNotification(
              "Error",
              warningMessage,
              "OK",
              "warning",
              notificationDuration.medium
            );
            return;
          }
          openNotification(
            DEFAULT_ERROR_TITLE,
            DEFAULT_ERROR_MESSAGE,
            "OK",
            "error",
            notificationDuration.medium
          );
          reject(error);
        })
        .finally(() => {
          dispatch(cloneWebsitePageWaitingForServer(false));
        });
    });
  };
};

export const deletePage = (page) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (!page) return;

      const { auth, websites } = getState();
      const { currentWebsitePage } = dispatch(getCurrentStoreData());

      const currentPageWebsite = websites.items.find(
        (website) => website.id === page.website
      );

      dispatch(deleteWebsitePageWaitingForServer(true));
      deletePageAsync({
        accessToken: auth.accessToken,
        subdomain: currentPageWebsite.subdomain,
        pageUrl: page.url || "home",
      })
        .then((response) => {
          dispatch(
            setPageLoadStatus({
              pageId: page.id,
              status: LoadStatus.DELETED,
            })
          );
          dispatch(
            removeSingleWebsitePageFromStore({
              websiteId: currentPageWebsite.id,
              pageUrl: page.url,
            })
          );
          resolve(response);
        })
        .catch((error) => {
          console.error(error.response);
          openNotification(
            DEFAULT_ERROR_TITLE,
            DEFAULT_ERROR_MESSAGE,
            "OK",
            "error",
            notificationDuration.medium
          );
          reject(error);
        })
        .finally(() => {
          dispatch(deleteWebsitePageWaitingForServer(false));
        });
    });
  };
};
